import * as React from 'react';
import { controller as ScopeController } from './scope';
import Accent from './accent';

export default function({ style, scopeCtl, accent, setAccent, drawingType, setDrawingType, onPrevPage, onNextPage, onPage, onSave, onLoad }: {
    style?: React.CSSProperties,
    scopeCtl: ScopeController,
    accent: string,
    setAccent: (accent: string) => void,
    drawingType: 'pen' | 'eraser' | null,
    setDrawingType: (drawingType: 'pen' | 'eraser' | null) => void,
    onPrevPage: () => void,
    onNextPage: () => void,
    onPage: (page: number) => void,
    onSave: () => void,
    onLoad: () => void,

}) {
    return (
    <div style={style || {}}>
        <Accent accent={accent} onSelect={setAccent}/>
        <button onClick={() => {
            scopeCtl.fit();
        }}>-</button>
        <button onClick={() => {
            scopeCtl.zoomin('右下');
        }}>+</button>
        <button onClick={() => {
            setDrawingType(null);
        }}>cursor</button>
        <button onClick={() => {
            setDrawingType('pen');
        }}>pen</button>
        <button onClick={() => {
            setDrawingType('eraser');
        }}>eraser</button>
        <button onClick={onPrevPage}>上一頁</button>
        <button onClick={onNextPage}>下一頁</button>
        <input type='number' placeholder='頁碼' style={{ width: '60px' }}
            onKeyDown={e => {
                if (e.key === 'Enter') {
                    onPage(e.currentTarget.valueAsNumber);
                }
            }}
        />
        {/* <button onClick={onSave}>存檔</button>
        <button onClick={onLoad}>載入</button> */}
    </div>);
}
